export default {
    priority: 93,
    name: app.translate('routes.home.attendance.leave.auto transfer'),
    path: 'AmountLeave',
    permissions: ['TimeAttendanceMenu/RemainingLeaveMenu/GeneralLeaveTransferMenu'],
    component: load(() => import(/* webpackChunkName: "auto transfer" */ './AutoTransferLeaveAmount')),
    icon: 'folder-move',
    drawer: true,
};